export const aboutData = {
  brandName: "51每日大赛",
  tagline: "资深吃瓜群众的深夜专属基地",
  description:
    "51每日大赛创立于2023年，是国内领先的娱乐八卦爆料平台。我们拥有遍布全国的专业爆料团队，24小时不间断追踪素人网红翻车现场、娱乐圈不雅内幕以及全网反差视频。我们不生产八卦，我们只是真相的搬运工——每一份爆料都经过严格核实，确保信息真实可靠。深夜不打烊，吃瓜不间断，用最犀利的角度带你穿透娱乐圈的重重迷雾。",
  stats: [
    { value: "128,600+", label: "累计爆料总数" },
    { value: "24/7", label: "实时追踪时长" },
    { value: "890万+", label: "月活跃吃瓜人" },
  ],
  channels: [
    {
      id: "channel-1",
      title: "网红翻车现场",
      tag: "热门频道",
      description: "第一时间直击素人网红人设崩塌全记录",
      image: "https://readdy.ai/api/search-image?query=Dramatic%20stage%20spotlight%20turning%20off%2C%20empty%20stage%20with%20fallen%20microphone%2C%20dark%20theater%20atmosphere%2C%20warm%20amber%20light%20fading%2C%20cinematic%20composition%2C%20conceptual%20art%20style%2C%20deep%20shadows%2C%20editorial%20photography&width=800&height=1000&seq=about-channel-card-01&orientation=portrait",
      color: "primary",
      size: "large",
    },
    {
      id: "channel-2",
      title: "反差视频精选",
      tag: "每日更新",
      description: "台前幕后巨大反差，揭开网红真面目",
      image: "https://readdy.ai/api/search-image?query=Two-faced%20theater%20mask%20concept%2C%20one%20side%20smiling%20golden%2C%20other%20side%20dark%20and%20cracked%2C%20dramatic%20side%20lighting%2C%20minimalist%20dark%20background%2C%20artistic%20photography%2C%20teal%20and%20warm%20tone%20contrast&width=800&height=500&seq=about-channel-card-02&orientation=landscape",
      color: "accent",
      size: "small",
    },
    {
      id: "channel-3",
      title: "酒店猛料曝光",
      tag: "独家内幕",
      description: "娱乐圈不为人知的秘密，每日震撼更新",
      image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20with%20unmade%20bed%20and%20scattered%20rose%20petals%2C%20dim%20warm%20lighting%2C%20half-open%20curtains%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20amber%20and%20rose%20tones%2C%20editorial%20photography%20with%20grain&width=800&height=500&seq=about-channel-card-03&orientation=landscape",
      color: "secondary",
      size: "small",
    },
  ],
  teamValues: [
    { icon: "ri-eye-line", title: "真实第一", desc: "每一条爆料都经过严格核实，不传谣不信谣" },
    { icon: "ri-flashlight-line", title: "速度至上", desc: "24小时实时追踪，比热搜还快的吃瓜体验" },
    { icon: "ri-shield-check-line", title: "保护信源", desc: "严格保护爆料人隐私，绝不泄露信息来源" },
  ],
};